@if (horizontalMenu) {
  <div class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item">
        <a class="navbar-brand" [routerLink]="['/']">
          <span class="brand-logo">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
          </span>
          <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
        </a>
      </li>
    </ul>
    <!--/ Navbar brand -->
  </div>
}

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    @if (!coreConfig.layout.menu.hidden) {
      <ul class="nav navbar-nav d-xl-none">
        <li class="nav-item">
          <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
            <span [data-feather]="'menu'" [class]="'ficon'"></span>
          </a>
        </li>
      </ul>
    }
    <!--/ Menu Toggler -->

    @if (!environment.production) {
      <div class="badge bg-dark">{{environment.mode}}</div>
    }

    <!-- Bookmark -->
    <!-- <xbaht-navbar-bookmark></xbaht-navbar-bookmark> -->
    <!--/ Bookmark -->
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection -->
    <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i><span
      class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a>
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        @for (lang of _translateService.getLangs(); track lang) {
          <a ngbDropdownItem (click)="setLanguage(lang)">
            <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title
            }}
          </a>
        }
      </div>
    </li>
    <!--/ Language selection -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'"
        class="ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->

    <!-- Search -->
    <!-- <xbaht-navbar-search></xbaht-navbar-search> -->
    <!--/ Search -->

    <!-- Cart -->
    <!-- <xbaht-navbar-cart></xbaht-navbar-cart> -->
    <!--/ Cart -->

    <!-- Notification -->
    <!-- <xbaht-navbar-notification></xbaht-navbar-notification> -->
    <!--/ Notification -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      @if (user$ | async; as user) {
        <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
          id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder">{{user.first_name}} {{user.last_name}}</span><span class="user-status">{{user.roles[0]}}</span>
          </div>
          <div class="avatar bg-light-primary avatar-lg">
            <div class="avatar-content">{{user.first_name[0]}}{{user.last_name[0]}}</div><span class="avatar-status-online"></span>
          </div>
        </a>
      }
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <a ngbDropdownItem [routerLink]="['/', 'profile']">
          <span [data-feather]="'user'" [class]="'mr-50'"></span> {{"BUTTON.PROFILE" | translate}}
        </a>
        <!-- <a ngbDropdownItem [routerLink]="['/']">
          <span [data-feather]="'mail'" [class]="'mr-50'"></span> Inbox
        </a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/']">
          <span [data-feather]="'check-circle'" [class]="'mr-50'"></span> Task
        </a> -->
        <!-- <a ngbDropdownItem [routerLink]="['/']">
          <span [data-feather]="'message-circle'" [class]="'mr-50'"></span> Chats
        </a> -->
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="onSignOut()">
          <span [data-feather]="'power'" [class]="'mr-50'"></span> {{"BUTTON.LOGOUT" | translate}}
        </a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>